require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-city-of-indianapolis-declares-april-10-financial-center-first-credit-union.json") })
        }
      }, "path---es-articles-city-of-indianapolis-declares-april-10-financial-center-first-credit-union");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-city-of-indianapolis-declares-april-10-financial-center-first-credit-union!./.cache/json/es-articles-city-of-indianapolis-declares-april-10-financial-center-first-credit-union.json
// module id = 2046
// module chunks = 231608221292675